import { Col, Container, Row } from "react-bootstrap";
import { FaFilePdf, FaFileExcel } from "react-icons/fa";

 
const RunnerUpHeaderNew = ({ title, state, onPdfClick, onExcelClick }) => {
  return (
    <Container fluid className="p-3  shadow-sm  mb-2" style={{background: "rgb(31 56 150)"}}>
      <Row className="align-items-center  text-md-start g-2">
 
        {/* Title (always required) */}
        <Col
          xs={12}
          md={state || onPdfClick || onExcelClick ? 6 : 12}
          className="fw-700 fs-3 text-lg-start text-xs-center"
          style={{ maxWidth: "100%",color:"white",fontWeight: "bolder",fontSize:"15px",
    textTransform: "uppercase" }}
          title={title}
        >
          {title}
        </Col>
 
        {/* State (optional) */}
        {state && (
          <Col xs={6} md={3} className=" fs-6" style={{ maxWidth: "100%",color:"white",fontWeight: "bolder",
    textTransform: "uppercase" }}>
            {state}
          </Col>
        )}
 
        {/* Icons (optional) */}
        {(onPdfClick || onExcelClick) && (
          <Col
            xs={6}
            md={3}
            className="d-flex justify-content-center justify-content-md-end gap-5"
            style={{gap:"10px"}}
          >
            {onPdfClick && (
              <FaFilePdf
                size={30}
                className="text-danger cursor-pointer"
                onClick={onPdfClick}
                title="Download PDF"
              />
            )}
            {onExcelClick && (
              <FaFileExcel
                size={30}
                className="text-success cursor-pointer"
                onClick={onExcelClick}
                title="Download Excel"
              />
            )}
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default RunnerUpHeaderNew